function combineFeaturePermissions(featurePermissions) {
  const combinedPermissions = {
    disabledReasons: [],
    hasQueryError: false,
    hasFeatureAccess: false
  };
  featurePermissions.forEach(({
    query,
    disabledReason,
    hasFeatureAccess
  }) => {
    if (disabledReason) {
      combinedPermissions.disabledReasons.push(disabledReason);
    }
    combinedPermissions.hasQueryError || (combinedPermissions.hasQueryError = !!query.error);
    combinedPermissions.hasFeatureAccess || (combinedPermissions.hasFeatureAccess = hasFeatureAccess);
  });
  return combinedPermissions;
}
export { combineFeaturePermissions };